let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("af9eo")).then(() => parcelRequire('iLXzZ'));